import { DialogContent, DialogTitle } from '@mui/material';
import { ReactNode } from 'react';
import { ButtonsSettings, StyledDialog } from 'components/dialog/Dialog.styles.tsx';

export type Props = {
  open: boolean;
  onCancel?: () => void;
  children: ReactNode;
  title?: string;
  buttonsSettings?: ButtonsSettings;
};

const ViewDialog = ({ children, onCancel, open, title }: Props) => {
  const handleClose = () => {
    if (onCancel) {
      onCancel();
    }
  };

  return (
    <StyledDialog open={open} onClose={handleClose} maxWidth="xl" scroll="paper">
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>{children}</DialogContent>
    </StyledDialog>
  );
};

export default ViewDialog;
